import React from 'react';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';

export const CustomModal = ({
  open,
  onClose,
  onBack,
  children,
  title,
  titleFullLine,
  leftAligned = true,
  height,
  maxWidth,
  isBack,
  className,
  titleFullLineClassName
}) => {

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        onClick={e => e.stopPropagation()}
        maxWidth={maxWidth ? maxWidth : 'md'}
        fullWidth
        sx={{
          '& .MuiDialog-paper': leftAligned
            ? {
              position: 'fixed',
              right: 0,
              top: 0,
              bottom: 0,
              width: { xxs: '95vw', xs: '80vw' },
              margin: 0,
              borderRadius: 0,
              height: '100dvh',
              maxHeight: '100dvh'
            }
            : {
              margin: 0,
              width: '95%',
              maxHeight: '100dvh'
            }
        }}
      >
        <div
          className={`!overflow-auto !w-full flex flex-col ${leftAligned ? "min-h-full" : height ? height : "h-[calc(100vh - 170px)]"}`}
        >
          <div className={`flex !w-full bg-white sticky top-0 z-10 pb-3 ${className}`}>
            {isBack && (
              <IconButton
                aria-label='close'
                onClick={() => (onBack ? onBack() : onClose?.())}
                sx={{ alignSelf: 'flex-start', color: 'primary.main' }}
                className='!absolute sm:!top-3 !top-2 !left-1 sm:!left-2'
              >
                <ArrowBackIosRoundedIcon className='!text-[1rem]' />
              </IconButton>
            )}
            {title ? (
              <div className={`horizontal-center w-full`}>
                <div className='flex flex-col gap-2 w-fit'>
                  <p className={`!font-notodisplay !font-light text-center horizontal-center !h-10 !w-full !text-responsive ${leftAligned ? '!mt-6 sm:!mt-10' : '!mt-6 !px-2'}`}>
                    {title}
                  </p>
                  {titleFullLine ? (
                    <div className={`w-full h-0.5 bg-primary-main mx-auto ${titleFullLineClassName}`} />
                  ) : (
                    <div className={`w-full max-w-[114px] h-0.5 bg-primary-main mx-auto ${titleFullLineClassName}`} />
                  )}
                </div>
              </div>
            ) : null}

            <IconButton
              aria-label='close'
              onClick={onClose}
              sx={{ alignSelf: 'flex-end', color: 'primary.main' }}
              className='!bg-white !absolute sm:!top-3 !top-1 !right-0 sm:!right-2'
            >
              <CloseRoundedIcon className='!text-[1.5rem]' />
            </IconButton>
          </div>

          {children}
        </div>
      </Dialog>
    </React.Fragment>
  );
};
